import React from 'react';

interface ApiIconProps {
  className?: string;
}

const ApiIcon: React.FC<ApiIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="M21,12c0-.54-.05-1.08-.15-1.63l3.05-1.75-2.99-5.2-3.05,1.75c-.84-.72-1.81-1.28-2.86-1.65V0h-6V3.52c-1.05,.37-2.02,.93-2.86,1.65l-3.05-1.75L.1,8.62l3.05,1.75c-.1,.54-.15,1.09-.15,1.63s.05,1.08,.15,1.63L.1,15.38l2.99,5.2,3.05-1.75c.84,.72,1.81,1.28,2.86,1.65v3.52h6v-3.52c1.05-.37,2.02-.93,2.86-1.65l3.05,1.75,2.99-5.2-3.05-1.75c.1-.54,.15-1.09,.15-1.63Zm-11.29,1.75l-1.41,1.41-1.71-1.71c-.78-.78-.78-2.04,0-2.81l1.71-1.71,1.41,1.41-1.71,1.71,1.71,1.69Zm2.27,3.45l-1.96-.39,2-10,1.96,.39-2,10Zm5.44-3.75l-1.71,1.71-1.41-1.41,1.71-1.71-1.71-1.7,1.41-1.41,1.71,1.71c.78,.78,.78,2.04,0,2.81Z"/>
    </svg>
  );
};

export default ApiIcon;
